import React from "react";
import InputWrapper from "../../Inputs/InputWrapper";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../../helpers/signUpFormConstants";
import FloatingLabelInput from "../../Inputs/FloatingLabelInput";
import { useEffect, useState } from "react";
import { SignUpFormData } from "../../../../SignUpFormTypes/signUpFormTypes";
import OtherProfessionInput from "./OtherProfessionInput";
import SelectOptions from "./SelectOptions";

const ProfessionInput = () => {
  const { control, setValue, watch } = useFormContext<SignUpFormData>();
  const INPUT_NAME = "profession";
  const [showOptions, setShowOptions] = useState(false);

  const professionValue = watch(INPUT_NAME);

  useEffect(() => {
    if (professionValue !== "Select one") setShowOptions(false);
  }, [professionValue]);

  const handleShowOptions: React.MouseEventHandler<HTMLInputElement> = e => {
    e.preventDefault();
    if (showOptions)
      (e.currentTarget.children[0].children[0] as HTMLElement).blur();

    return setShowOptions(!showOptions);
  };

  return (
    <>
      <Controller
        name={INPUT_NAME}
        rules={signUpFormValidators.notSelectOne}
        control={control}
        render={({ field, fieldState: { invalid, isTouched } }) => (
          <div
            className="flex flex-col gap-3 w-full"
            onClick={handleShowOptions}
          >
            <InputWrapper
              errorMsg="Choose the option that best describes your practice"
              hasError={invalid && isTouched && !showOptions}
              label="What best describes your practice?"
              valid={!invalid && isTouched}
              valueExists={!!field.value}
              isSelectInput
              name={INPUT_NAME}
            >
              <FloatingLabelInput
                hasError={invalid && isTouched && !showOptions}
                readOnly
                isSelectInput
                {...field}
              />
            </InputWrapper>
            {showOptions && (
              <SelectOptions
                showOptions={setShowOptions}
                selected={field.value}
                setValue={setValue}
              />
            )}
          </div>
        )}
      />
      {professionValue === "Other" && <OtherProfessionInput />}
    </>
  );
};

export default ProfessionInput;
